import Resolver from 'src/common/Resolver';
import useParticipantsStore from 'src/stores/participantsStore';

import MergeParticipants from './MergeParticipants';

const MergeParticipantsResolver = () => {
  const fetchMergeCandidates = useParticipantsStore(s => s.fetchMergeCandidates);

  return (
    <Resolver
      resolve={() => fetchMergeCandidates()}
      successComponent={MergeParticipants}
    />
  );
};

export default MergeParticipantsResolver;
